"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogConfig = exports.LOG_FILTER_TYPE = exports.LOG_LEVEL = void 0;
var LOG_LEVEL;
(function (LOG_LEVEL) {
    LOG_LEVEL[LOG_LEVEL["LOG_LEVEL_NONE"] = 0] = "LOG_LEVEL_NONE";
    LOG_LEVEL[LOG_LEVEL["LOG_LEVEL_INFO"] = 1] = "LOG_LEVEL_INFO";
    LOG_LEVEL[LOG_LEVEL["LOG_LEVEL_WARN"] = 2] = "LOG_LEVEL_WARN";
    LOG_LEVEL[LOG_LEVEL["LOG_LEVEL_ERROR"] = 4] = "LOG_LEVEL_ERROR";
    LOG_LEVEL[LOG_LEVEL["LOG_LEVEL_FATAL"] = 8] = "LOG_LEVEL_FATAL";
    LOG_LEVEL[LOG_LEVEL["LOG_LEVEL_API_CALL"] = 16] = "LOG_LEVEL_API_CALL";
    LOG_LEVEL[LOG_LEVEL["LOG_LEVEL_DEBUG"] = 32] = "LOG_LEVEL_DEBUG";
})(LOG_LEVEL || (exports.LOG_LEVEL = LOG_LEVEL = {}));
var LOG_FILTER_TYPE;
(function (LOG_FILTER_TYPE) {
    LOG_FILTER_TYPE[LOG_FILTER_TYPE["LOG_FILTER_OFF"] = 0] = "LOG_FILTER_OFF";
    LOG_FILTER_TYPE[LOG_FILTER_TYPE["LOG_FILTER_DEBUG"] = 2063] = "LOG_FILTER_DEBUG";
    LOG_FILTER_TYPE[LOG_FILTER_TYPE["LOG_FILTER_INFO"] = 15] = "LOG_FILTER_INFO";
    LOG_FILTER_TYPE[LOG_FILTER_TYPE["LOG_FILTER_WARN"] = 14] = "LOG_FILTER_WARN";
    LOG_FILTER_TYPE[LOG_FILTER_TYPE["LOG_FILTER_ERROR"] = 12] = "LOG_FILTER_ERROR";
    LOG_FILTER_TYPE[LOG_FILTER_TYPE["LOG_FILTER_CRITICAL"] = 8] = "LOG_FILTER_CRITICAL";
    LOG_FILTER_TYPE[LOG_FILTER_TYPE["LOG_FILTER_MASK"] = 2063] = "LOG_FILTER_MASK";
})(LOG_FILTER_TYPE || (exports.LOG_FILTER_TYPE = LOG_FILTER_TYPE = {}));
class LogConfig {
}
exports.LogConfig = LogConfig;
